import { render, staticRenderFns } from "./DashboardRepresentative.vue?vue&type=template&id=7b1dc464&scoped=true&"
import script from "./DashboardRepresentative.vue?vue&type=script&lang=js&"
export * from "./DashboardRepresentative.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRepresentative.vue?vue&type=style&index=0&id=7b1dc464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1dc464",
  null
  
)

export default component.exports